import { useCallback } from "react";
import useI18n from "@I18n/hooks/useI18n";
import { stringify as queryStringStringify } from "qs";
import { generatePath as reactRouterGeneratePath, Params } from "react-router";

function getTopLevelDomain() {
  const { origin } = window?.location;
  const urlObj = new URL(origin);
  const domain = urlObj.hostname;
  const splitedDomain = domain.split(".");
  const tld =
    Array.isArray(splitedDomain) && splitedDomain.length > 1
      ? splitedDomain.pop().toLocaleLowerCase()
      : undefined;
  return tld;
}

function removeLocalFromPath(path) {
  const splitPath = path && path.split("/").filter((item) => item);

  // checks if it has locale and tries to remove it
  if (
    Array.isArray(splitPath) &&
    ["fr", "nl"].filter((item) => item === splitPath[0]).length > 0
  )
    return `/${splitPath.slice(1).join("/")}`;
  return path; // if there is no local attached to the path
}

export type GeneratePath = (
  path: string,
  params?: Params,
  queryParams?: Params
) => string;

type IUsePath = () => { generatePath: GeneratePath };

export const usePath: IUsePath = () => {
  const { locale } = useI18n();

  const generatePath: GeneratePath = useCallback(
    (path, params, queryParams) => {
      let resolvedPath = reactRouterGeneratePath(path, { locale, ...params });

      /**
       * checks if domain is france origin and removes /fr on and route.
       * example: '/fr/listworker-rules' & "/fr/supertalent" will be "/listworker-rules" and "/supertalent"
       */
      const topLevelDomain = getTopLevelDomain();
      if (topLevelDomain === "fr") {
        resolvedPath = removeLocalFromPath(resolvedPath);
      }

      if (!queryParams) return resolvedPath;

      const { anchor, ...urlQueryParams } = queryParams;

      const queryString = queryStringStringify(urlQueryParams);

      let result = `${resolvedPath}?${queryString}`;
      result = anchor ? `${result}#${anchor}` : result;
      return result;
    },
    [locale]
  );

  return { generatePath };
};
